import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
// filters combos
import { ComboCliente, ComboGrupo } from '../../../../core/model/combos';
import { ResizedEvent } from '../../../../core/model/resized-event';
import { SpecialFormValidators } from '../../../../core/model/specialFormValidators';
import { NuevaPeticion, Userprofile, UsuarioSearch } from '../../../../core/model/users';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { PopulateService } from '../../../../core/services/populate.service';
import { SessionService } from '../../../../core/services/session.service';
// users information
import { UsersService } from '../../../../core/services/users.service';
import { Page } from './../../../../core/model/page';
import { UtilitiesService } from './../../../../core/services/Utility/utilities.service';
import { ActionConfirmation } from './actions';






function TieneSeleccion(input: FormControl) {
  const hasSelect = input.value !== '-1';
  return hasSelect ? null : { needsSelect: hasSelect };
}


@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers: [BsModalService, PopulateService]
})
export class UsuariosComponent implements OnInit, OnDestroy {
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  private subscription;
  private subscription_change;
  private subscription_users;
  private subscription_action;

  isDocoutUser = false;
  isSupervisor: boolean;
  idcliente: number;
  statusCode: number;
  requestProcessing = false;
  noHayUsuarios = false;
  messageToShow: string;
  page = new Page();

  buttonPressed = false;


  @ViewChild('tblusers') table: any;
  rows = [];
  selected = [];
  multi_selected = [];

  // Modelos formulario
  allUsers: Userprofile[];
  usersSearch: UsuarioSearch = new UsuarioSearch();


  modalRef: BsModalRef;
  modalConfig: ActionConfirmation[];
  id_action: number;

  cbCliente: ComboCliente[];
  cbGrupo: ComboGrupo[];
  cbClientePop: ComboCliente[];
  cbGrupoPop: ComboGrupo[];
  tableColumns: any[] = [];

  // Creamos el formulario
  filterForm = new FormGroup({
    usuario_filter: new FormControl(''),
    nombre_filter: new FormControl(''),
    email_filter: new FormControl(''),
    cliente_filter: new FormControl(undefined),
    grupo_filter: new FormControl(undefined),
    estado_filter: new FormControl('-1')
  });

  model = new NuevaPeticion();

  userForm = this.fb.group({
    'cliente': new FormControl('-1', [Validators.required]),
    'nombre': new FormControl('', [Validators.required, Validators.maxLength(50)]),
    'apellidos': new FormControl('', [Validators.required, Validators.maxLength(50)]),
    'email': new FormControl('', [Validators.required, Validators.email, Validators.maxLength(50)]),
    'roluser': new FormControl('-1', [Validators.required, TieneSeleccion]),
    'grupousuario': new FormControl('-1', [Validators.required, TieneSeleccion]),
    'telefono': new FormControl('-1', [SpecialFormValidators.validateMovilNumber])
  });

  get cliente() { return this.userForm.get('cliente'); }
  get nombre() { return this.userForm.get('nombre'); }
  get apellidos() { return this.userForm.get('apellidos'); }
  get email() { return this.userForm.get('email'); }
  get roluser() { return this.userForm.get('roluser'); }
  get grupousuario() { return this.userForm.get('grupousuario'); }
  get telefono() { return this.userForm.get('telefono'); }

  clienteSeleccionado = undefined;

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };


  constructor(private translateService: TranslateService,
    private authService: AuthenticationService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private userservice: UsersService,
    private populateService: PopulateService,
    private utilservice: UtilitiesService,
    private sessionService: SessionService,
    private fb: FormBuilder) {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  // region "Initialize"

  ngOnInit() {

    this.SetEnviroment();
    this.InitLanguage();
    this.configActions();
    this.getFilters();
    this.initTableColumns();
    // this.getAllUsers();
    this.searchForm(); // <- este llama a findusers (formateamos lso valores a psar a la API)
  }

  private initTableColumns() {
    this.tableColumns = [
      { name: this.translateService.instant('usuarios.columns.Id'), prop: 'Id' },
      { name: this.translateService.instant('usuarios.columns.Client'), prop: 'NOMBRE_CLIENTE' },
      { name: this.translateService.instant('usuarios.columns.User'), prop: 'USER' },
      { name: this.translateService.instant('usuarios.columns.Profile'), prop: 'SUPERVISOR' },
      { name: this.translateService.instant('usuarios.columns.Name'), prop: 'NOMBRE' },
      { name: this.translateService.instant('usuarios.columns.Surnames'), prop: 'APELLIDOS' },
      { name: this.translateService.instant('usuarios.columns.Email'), prop: 'EMAIL' },
      { name: this.translateService.instant('usuarios.columns.State'), prop: 'ACTIVO' }
    ];

  }


  SetEnviroment() {
    this.isSupervisor = this.authService.isSupervisorUser() || this.authService.isAdminUser();

    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
        this.getFilters();
      });

    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    });

    this.idcliente = this.sessionService.getClientId();

  }


  InitLanguage() {
    this.subscription = this.translateService.get(['usuarios'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['usuarios'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }
  TranslateText(values: any) {
    this.Title = values['usuarios']['cabecera'];
    this.Description = values['usuarios']['descripcion'];
    this.Hijo = values['usuarios']['cabecera'];
  }


  configActions() {
    this.modalConfig = [
      new ActionConfirmation(1, 'bg-danger', 'fas fa-trash fa-4x', 'Desactivar', 'Va a desactivar a los usuarios seleccionados.'),
      new ActionConfirmation(2, 'bg-danger', 'fas fa-trash fa-4x', 'Desactivar', 'Va a desactivar al usuario seleccionado.'),
      new ActionConfirmation(3, 'bg-success', 'fas fa-check-circle fa-4x', 'Activar', 'Va a activar al usuario seleccionado.'),
      new ActionConfirmation(4, 'bg-info', 'fas fa-check-circle fa-4x', 'Detalle', 'Va a DETALLEEEEE al usuario.'),
      new ActionConfirmation(5, 'bg-primary', 'fas fa-envelope fa-4x', 'Resetear clave',
        'Va a resetear la clave al usuario. Se le enviará un email al usuario con las instrucciones de reseteo.')
    ];
  }

  // endregion

  // region "Filtros"

  getFilters() {
    if (this.isDocoutUser) {
      this.getClientes();
    } else {
      this.getGroupByCliente(this.idcliente);
      this.getGroupByClientePop(this.idcliente);
    }
  }

  getClientes() {
    this.subscription_action = this.populateService.getComboCliente()
      .subscribe(
        clientes => {
          this.cbCliente = clientes;
          this.cbClientePop = clientes;
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }


  onClientChange(idcliente: number) {
    this.filterForm.patchValue({ grupo_filter: undefined });
    this.cbGrupo = [];
    // if ( !isNaN(idcliente) && Number(idcliente)) {
    //     this.getGroupByCliente(idcliente);
    //   }
    if (idcliente && idcliente != 0) {
      this.getGroupByCliente(idcliente);
    }
  }

  getGroupByCliente(identificador: number) {
    this.subscription_action = this.populateService.getComboGrupoByCliente(identificador)
      .subscribe(
        grupo => {
          this.cbGrupo = grupo;
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }



  resetForm() {
    if (this.filterForm != null) {
      this.filterForm.setValue({
        usuario_filter: '',
        nombre_filter: '',
        email_filter: '',
        cliente_filter: null,
        grupo_filter: null,
        estado_filter: '-1'
      });
      // Reiniciamos combos dependientes
      if (this.isDocoutUser) {
        this.onClientChange(-1);
      }
    }
  }

  searchForm(resetPage?: boolean) {
    //  this.usersSearch.ID_CLIENTE = this.filterForm.controls['cliente_filter'].value === '-1' ? undefined : this.filterForm.controls['cliente_filter'].value;
    //  this.usersSearch.ID_GRUPO = this.filterForm.controls['grupo_filter'].value === '-1' ? undefined : this.filterForm.controls['grupo_filter'].value;
    //  this.usersSearch.ACTIVO = this.filterForm.controls['estado_filter'].value === '-1' ?
    //  undefined : this.filterForm.controls['estado_filter'].value === '1' ? true : false;


    this.usersSearch.ID_CLIENTE = this.filterForm.controls['cliente_filter'].value === undefined ? undefined : this.filterForm.controls['cliente_filter'].value;
    this.usersSearch.ID_GRUPO = this.filterForm.controls['grupo_filter'].value === undefined ? undefined : this.filterForm.controls['grupo_filter'].value;
    this.usersSearch.ACTIVO = this.filterForm.controls['estado_filter'].value === '-1' ?
      undefined : this.filterForm.controls['estado_filter'].value === '1' ? true : false;
    this.usersSearch.NOMBREAPES = this.filterForm.controls['nombre_filter'].value === '' ? undefined : this.filterForm.controls['nombre_filter'].value;
    this.usersSearch.USERNAME = this.filterForm.controls['usuario_filter'].value === '' ? undefined : this.filterForm.controls['usuario_filter'].value;
    this.usersSearch.EMAIL = this.filterForm.controls['email_filter'].value === '' ? undefined : this.filterForm.controls['email_filter'].value;


    this.getFindUsers(resetPage);
  }



  // endregion
  getAllUsers() {

    this.preProcessLoader('Cargando usuarios...');
    if (this.subscription_users != null) { this.subscription_users.unsubscribe(); }
    this.subscription_users = this.userservice.getAllUsers()
      .subscribe(
        data => {
          this.allUsers = new Array();
          this.allUsers = data;
          for (let index = 0; index < data.length; index++) {
            this.noHayUsuarios = false;
            break;
          }
          this.requestProcessing = false;
          if (data.length <= 0 || data == null) {
            this.noHayUsuarios = true;
          }
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.noHayUsuarios = true;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nosolicitudes'],
                values['mensajes']['nosolicitudestitle']);
            });
        });
  }


  getFindUsers(resetPage?: boolean) {
    this.preProcessLoader('Cargando usuarios...');
    if (resetPage) {
      this.page.pageNumber = 0;
    }
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + (+this.page.size);

    if (this.subscription_users != null) { this.subscription_users.unsubscribe(); }

    this.getPaginationUsers(inicio, fin);
  }

  private getPaginationUsers(inicio: number, fin: number) {
    this.subscription_users = this.userservice.getFindUsers(this.usersSearch, inicio, fin)
      .subscribe(
        data => {
          this.allUsers = data.DataList;
          this.page.totalElements = data.TotalResults;
          this.noHayUsuarios = !this.allUsers.length;
          this.requestProcessing = false;
          this.multi_selected = [];
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.noHayUsuarios = true;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nosolicitudes'],
                values['mensajes']['nosolicitudestitle']);
            });
        });
  }


  // region "Events select"
  onMultiSelect({ multi_selected }) {
    this.multi_selected.splice(0, this.multi_selected.length);
    this.multi_selected.push(...multi_selected);
  }

  OnSelectAll() {
    if (this.multi_selected.length) {
      this.multi_selected = [];
    } else {
      this.multi_selected = this.allUsers;
    }
  }

  // endregion


  // region "Confirmation Modal"
  ConfirmationSingle(template: TemplateRef<any>, event, row: any) {
    event.stopPropagation();
    this.multi_selected = [];
    this.multi_selected.push(row);
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr != null) {
      this.id_action = idAttr.nodeValue;
    } else {
      this.id_action = -1;
    }

  }

  ConfirmationMultiple(template: TemplateRef<any>, event) {
    event.stopPropagation();
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr != null) {
      this.id_action = idAttr.nodeValue;
    } else {
      this.id_action = -1;
    }

  }

  confirm(): void {
    // this.message = 'Confirmed!';
    switch (this.id_action.toString()) {
      case '1': // Desactivar todos los usuarios seleccionados
        this.disabledUser();
        break;
      case '2': // Desactivar single user
        this.disabledUser();
        break;
      case '3': // Activar single user
        this.enabledUser();
        break;
      case '5': // Activar single user
        this.forceUserPasswordReset();
        break;
      default:
        break;
    }
    this.multi_selected = [];
    this.modalRef.hide();

  }

  decline(): void {
    this.multi_selected = [];
    this.modalRef.hide();
  }

  // endregion

  // region "Users functions"
  disabledUser() {
    this.multi_selected.forEach(element => {
      this.changeStatus(element.Id, false);
    });
  }
  enabledUser() {
    this.multi_selected.forEach(element => {
      this.changeStatus(element.Id, true);
    });
  }

  forceUserPasswordReset() {
    this.multi_selected.forEach(element => {
      this.userservice.forceUserPasswordReset(element.USER)
        .subscribe(() => {
          if (console) {
            console.log('Solicitado reseteo de password para usuario ' + element.USER);
          }
          this.toastr.clear();
          this.toastr.success('Se ha enviado un correo al usuario para que reinicie su contraseña', 'Enviado correctamente');
        },
          error => {
            this.toastr.clear();
            this.toastr.error('No se ha podido enviar el correo para reiniciar la contraseña en estos momentos', 'Error de usuarios');
          });
    });
  }

  changeStatus(userId: number, estado: boolean) {

    this.subscription_action = this.userservice.changeStatusUser(userId, estado)
      .subscribe(successCode => {
        //  this.statusCode = successCode;
        //  Expecting success code 204 from server
        this.statusCode = 204;
        if (estado) {
          this.toastr.success('Usuario activado correctamente', 'Usuario activado');
        } else {
          this.toastr.success('Usuario desactivado correctamente', 'Usuario desactivado');
        }
        this.searchForm();
      },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nosolicitudes'],
                values['mensajes']['nosolicitudestitle']);
            });
        });
  }

  // endregion



  clickStopper(event) {
    event.stopPropagation();
    return;
  }


  preProcessLoader(mensaje: string) {
    this.messageToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }


  ngOnDestroy() {
    // console.log('Clear usuarios consulta');

    if (this.subscription != null) { this.subscription.unsubscribe(); }
    if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
    if (this.subscription_users != null) { this.subscription_users.unsubscribe(); }
    if (this.subscription_action != null) { this.subscription_action.unsubscribe(); }

    this.populateService = null;
    this.translateService = null;
    this.authService = null;
    this.userservice = null;
    this.modalService = null;
    this.toastr = null;
    this.fb = null;
  }

  // region "Nuevos usuarios"
  openNewUser(template: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template, { keyboard: false, ignoreBackdropClick: true });
    this.modalService.onHide.subscribe(() => {
      this.resetUserForm();
    });
  }

  closeModal() {
    this.modalRef.hide();
  }


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.id;

    if (idAttr != null) {
      if (charCode == 64 || charCode == 16) {
        // to allow numbers
        return false;
      } else if (charCode >= 48 && charCode <= 57) {
        // to allow numbers
        return true;
      } else if (charCode >= 96 && charCode <= 105) {
        // to allow numpad number
        return true;
      } else if ([13, 8, 9, 27, 37, 38, 39, 40].indexOf(charCode) > -1) {
        // to allow backspace, escape, arrows, tab, etc
        return true;
      } else {
        event.preventDefault();
        // to stop others
        return false;
      }


    } else { return false; }
  }


  onUserFormSubmit() {
    // [(ngModel)]="model.ID_GROUP"
    // [(ngModel)]="model.SUPERVISOR"
    // this.model = this.model;
    this.model.ID_GROUP = this.grupousuario.value;
    if (this.roluser.value == 1) {
      this.model.SUPERVISOR = true;
    } else {
      this.model.SUPERVISOR = false;
    }

    if (this.userForm.invalid) {
      return;
    }


    if (this.isDocoutUser) {
      this.altaNuevoUsuario();
    } else {
      this.crearNuevaPeticion();
    }

  }

  crearNuevaPeticion() {
    this.userservice.createNuevaPeticion(this.model)
      .subscribe(successCode => {
        this.statusCode = successCode;
        this.toastr.success('Petición añadida correctamente', 'Petición correcta');
        this.modalRef.hide();
        this.resetUserForm();
        this.searchForm();
      },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.toastr.warning('No se ha podido guardar su petición de usuario', 'Petición incorrecta');
        });
  }

  altaNuevoUsuario() {
    this.userservice.createUserDirecto(this.model)
      .subscribe(successCode => {
        this.statusCode = successCode;
        this.toastr.success('Usuario añadido correctamente', 'Nuevo usuario');
        this.modalRef.hide();
        this.resetUserForm();
        this.searchForm();
      },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.toastr.warning('No se ha podido guardar el usuario', 'Usuario incorrecto');
        });
  }

  onClientChangePop(idcliente: number) {
    this.userForm.patchValue({ grupousuario: '-1' });
    this.cbGrupoPop = [];

    if (idcliente !== null && idcliente > -1) {
      this.getGroupByClientePop(idcliente);
    }
  }


  getGroupByClientePop(identificador: number) {
    this.subscription_action = this.populateService.getComboGrupoByCliente(identificador)
      .subscribe(
        grupo => {
          this.cbGrupoPop = grupo;
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  resetUserForm() {
    if (this.userForm != null) {

      this.userForm.reset();
      this.userForm.patchValue({ cliente: '-1' });
      this.userForm.patchValue({ roluser: '-1' });
      this.userForm.patchValue({ grupousuario: '-1' });
      // Reiniciamos combos dependientes
      if (this.isDocoutUser) {
        this.onClientChangePop(-1);
      }
    }
  }
  // endregion

  onResized(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.searchForm();
  }

  exportAllDatas() {
    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.info(values['mensajes']['downloadfileinprogress']);
      });


    this.userservice.getFindUsers(this.usersSearch, 0, this.page.totalElements)
      .subscribe(
        data => {
          this.downloadCSVData(data.DataList);
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.error(values['mensajes']['errorDownloadingfile'],
                values['mensajes']['errorDownloadingfileTitle']);
            });
        });
  }

  downloadCSVData(values) {
    const csv = this.generateCSVFromValues(values);

    const fileName = this.translateService.instant('usuarios.exportFileName') + '.csv';

    this.utilservice.downloadDataInCSV(fileName, csv);

  }

  private getColumnsForUser(): any[] {
    const columns: any[] = [];
    this.tableColumns.forEach(column => {
      if (column.prop != 'NOMBRE_CLIENTE' || this.isDocoutUser) {
        columns.push(column);
      }
    });

    return columns;
  }

  private generateCSVFromValues(values: any): string {
    const columns = this.getColumnsForUser();
    let csvString = this.convertValuesToCSVRow(columns.map(column => column.name));

    values.forEach(value => {
      csvString += this.convertValuesToCSVRow(columns.map(column => this.getData(column.prop, value)));
    });

    return csvString;
  }

  private getData(prop: string, data: any): string {
    if (prop == 'SUPERVISOR') {
      const keyTranslate = data[prop] == 0 ? 'usuarios.operator' : 'usuarios.supervisor';
      return this.translateService.instant(keyTranslate);
    }

    if (prop == 'ACTIVO') {
      const keyTranslate = data[prop] == 0 ? 'usuarios.inactive' : 'usuarios.active';
      return this.translateService.instant(keyTranslate);
    }

    return data[prop];
  }


  private convertValuesToCSVRow(values: any[]): string {
    return values.join(';') + '\n';
  }

  hasButtonPressed(hasButtonPressed) {
    if (hasButtonPressed) {
      this.buttonPressed = true;
    }
  }

  activateRow(event) {
    if (event.type == 'click' && !this.buttonPressed) {
      if (this.isSelected(event.row)) {
        this.removeSelectedMultiselect(event.row);
      } else {
        this.multi_selected.push(event.row);
      }
    } else if (event.type == 'click') {
      this.buttonPressed = false;
    }
  }
  private removeSelectedMultiselect(row: any): any {
    const element = this.multi_selected.find(select => select.Id == row.Id);
    if (element) {
      this.multi_selected = this.multi_selected.filter(obj => obj !== element);
      return this.multi_selected;
    }
    return null;
  }
  private isSelected(row: any): any {
    return this.multi_selected.find(select => select.Id == row.Id) != null;
  }

  saveSecurityLevel(row, event) {
    this.userservice.changeLevelSecurity(row.Id, event)
      .subscribe(estado => {
        if (estado) {
          this.toastr.success(this.translateService.instant('usuarios.levelSecurityChanged'));
        } else {
          this.toastr.success(this.translateService.instant('usuarios.errorLevelSecurityChanged'));
        }
      });
  }

}
